import { useState, useEffect, useCallback } from 'react';
import { ArrowUp } from 'lucide-react';
import { cn } from '@/lib/utils';

export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY >= 350);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleClick = useCallback(() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
  }, []);

  return (
    <button
      onClick={handleClick}
      aria-label="Retour en haut de page"
      className={cn(
        'fixed bottom-6 right-6 z-50',
        'flex h-12 w-12 items-center justify-center rounded-full',
        'bg-[#1E4FA1] text-white',
        'shadow-[0_12px_28px_rgba(30,79,161,0.30)]',
        'hover:-translate-y-0.5 hover:bg-[#153A7A] hover:shadow-[0_16px_36px_rgba(30,79,161,0.36)]',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1E4FA1] focus-visible:ring-offset-2',
        'transition-all duration-300 motion-reduce:transition-none',
        visible
          ? 'opacity-100 translate-y-0 pointer-events-auto'
          : 'opacity-0 translate-y-2 pointer-events-none',
      )}
    >
      <ArrowUp size={22} strokeWidth={2.5} />
    </button>
  );
}
